/* Glamorush performance helpers. Loaded with defer right after global.min.js (needs jQuery_T4NT). */
(function () {
  try {
    var $ = window.jQuery_T4NT;
    if (!$ || !$.event) return;

    /* 1. The carousels fire a jQuery "scroll" event on every animation frame. jQuery then calls the
          element's native scroll() as the event's default action, which does nothing useful (it scrolls
          to where the element already is) but forces a full page layout each frame. Skip that call. */
    var sp = $.event.special;
    sp.scroll = sp.scroll || {};
    if (!sp.scroll._default) sp.scroll._default = function () { return true; };

    /* 2. While a carousel slides, Flickity checks which slides are on screen (twice per animation frame).
          It read one slide's position, then changed that slide's class, so the next read forced another
          full page layout: one per slide, per frame. Read every position first, then write only what changed.
          (is-t4s-visible has no CSS, and no aria-hidden rule touches slides, so the writes never move a slide.) */
    var F = window.Flickityt4s && window.Flickityt4s.prototype;
    if (F && F._checkVisibility) {
      F._checkVisibility = function () {
        if (!this.options.checkVisibility || !this.options.adaptiveHeight) return;
        var vx = this.viewport.getBoundingClientRect().x, vw = this.viewport.offsetWidth;
        var cells = this.cells, n = cells.length, xs = [], i;
        for (i = 0; i < n; i++) xs[i] = cells[i].element.getBoundingClientRect().x - vx;
        for (i = 0; i < n; i++) {
          var c = cells[i], el = c.element, s = xs[i], e = s + c.size.innerWidth;
          if ((e > vx && e < vw) || (s > vx && s < vw)) {
            this.maxVisibilityHeight = Math.max(c.size.outerHeight, this.maxVisibilityHeight);
            if (!el.classList.contains('is-t4s-visible')) el.classList.add('is-t4s-visible');
            if (el.hasAttribute('aria-hidden')) el.removeAttribute('aria-hidden');
          } else {
            if (el.classList.contains('is-t4s-visible')) el.classList.remove('is-t4s-visible');
            if (el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', 'true');
          }
        }
      };

      /* Same pattern on every slide change: only rewrite the arrow position when it actually moved. */
      F.setPrevNextButtons = function () {
        if (!this.options.setPrevNextButtons) return;
        var t = this.viewport.querySelector('.is-selected [data-cacl-slide]');
        if (t === null) return;
        var v = t.offsetHeight / 2 + 'px';
        if (this.element.style.getPropertyValue('--prev-next-top') !== v) this.element.style.setProperty('--prev-next-top', v);
      };
    }

    /* 3. Autoplay carousels keep sliding while off-screen. Pause each one until it scrolls into view.
          Also hold every autoplay until the visitor first scrolls, taps or types: sliding during page load
          kept a phone's main thread busy and the screen changing, so the page never finished loading. */
    if (!('IntersectionObserver' in window)) return;

    function flkty(el) {
      return (el.flickityt4s && el.flickityt4s.flkty) || $(el).data('flickityt4s');
    }

    var held = true;
    var watched = [];

    function apply(el) {
      var f = flkty(el);
      if (!f || !f.player || !f.options || !f.options.autoPlay) return !!f;
      if (el.__grOff || held) f.pausePlayer(); else f.unpausePlayer();
      return true;
    }

    var wake = ['scroll', 'pointerdown', 'touchstart', 'keydown', 'mousemove'];
    function release() {
      if (!held) return;
      held = false;
      wake.forEach(function (e) { window.removeEventListener(e, release, { passive: true }); });
      watched.forEach(apply);
    }
    wake.forEach(function (e) { window.addEventListener(e, release, { passive: true }); });

    var pending = [];
    var tries = 0;
    function retry() {
      pending = pending.filter(function (el) { return !apply(el); });
      if (pending.length && ++tries < 40) setTimeout(retry, 300);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.__grOff = !en.isIntersecting;
        if (!apply(en.target) && pending.indexOf(en.target) < 0) {
          pending.push(en.target);
          if (pending.length === 1) { tries = 0; setTimeout(retry, 300); }
        }
      });
    }, { rootMargin: '100px 0px' });

    function watch() {
      document.querySelectorAll('.flickityt4s').forEach(function (el) {
        if (el.__grIO) return;
        el.__grIO = 1;
        watched.push(el);
        io.observe(el);
      });
    }

    /* Returning to the browser tab un-pauses every carousel, so re-pause any that slide while off-screen. */
    $(document).on('change.flickityt4s', '.flickityt4s', function () {
      if (this.__grOff || held) apply(this);
    });

    /* 4. The theme builds every carousel on the page at once when it loads (14 on the homepage), which was
          the longest single task on phones. Build the ones near the screen right away and the rest as the
          visitor scrolls toward them. An unbuilt carousel already shows as one clipped row, so nothing moves. */
    var TS = window.T4SThemeSP;
    if (TS && TS.initCarousel && TS.Carousel) {
      var build = function (el) {
        if (el.flickityt4s || el.classList.contains('flickityt4s-enabled')) return;
        el.flickityt4s = new TS.Carousel(el);
        setTimeout(function () {
          /* Let the theme resize this carousel when its product cards change height, as it does for the others. */
          if (TS.ProductItem && TS.ProductItem.resizeObserver) TS.ProductItem.resizeObserver();
          apply(el);
        }, 0);
      };
      var lazy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          lazy.unobserve(en.target);
          build(en.target);
        });
      }, { rootMargin: '800px 0px' });
      TS.initCarousel = function () {
        var near = window.innerHeight * 1.5;
        var els = Array.prototype.filter.call(
          document.querySelectorAll('.flickityt4s:not(.flickityt4s-later):not(.flickityt4s-enabled)'),
          function (el) { return !el.flickityt4s && !el.__grLazy; });
        /* Read every position before building any, so building one does not force a re-layout for the next. */
        var tops = els.map(function (el) { return el.getBoundingClientRect().top; });
        els.forEach(function (el, i) {
          /* Hidden carousels (menus, drawers) report top 0, so they are still built straight away. */
          if (tops[i] < near) build(el);
          else { el.__grLazy = 1; lazy.observe(el); }
        });
      };
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    window.addEventListener('load', watch);
  } catch (e) {}
})();
